function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave13(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bc1938dc-93f4-40ce-9211-44320b7acc51",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "f8789de4-1517-4f45-bfc4-56dc6eb906bf",
    "data-name": "Wave-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aca9da98-b6fe-4b1d-87ca-fb866f2827c6",
    "data-name": "Rectangle",
    d: "M1366,18.26686C1058.49121,18.26686,882.61719,0,709.1875,0S337.7731,43.72023,0,48H1366Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave13;